import React, { useEffect } from "react";
import { Col, Alert, Row, Steps } from "antd";
import Step1 from "./Components/Step1";
import Step2 from "./Components/Step2";
import Step3 from "./Components/Step3";
import Step4 from "./Components/Step4";
import "./style.css";
import { useSelector } from "react-redux";

const items = [
  { title: "Location" },
  { title: "Land" },
  { title: "Priority" },
  { title: "Ranking" },
];

function WizardForm({ notselected }) {
  const wizardStep = useSelector((state) => state.wizard.wizardStep);

  const steps = [
    {
      step: 1,
      title: "Step1",
      content: <Step1 />,
    },
    {
      step: 2,
      title: "Step2",
      content: <Step2 />,
    },
    {
      step: 3,
      title: "Step3",
      content: <Step3 />,
    },
    {
      step: 4,
      title: "Step4",
      content: <Step4 s />,
    },
  ];

  return (
    <>
      <Row>
        {notselected && (
          <Alert
            message="Please select State and County to view available practices."
            type="error"
            closable
          />
        )}
        <Col span={20} offset={2} className="mt-3">
          <Steps className="wizard-steps" current={wizardStep} items={items} />
          <div className="wizard-steps-internal">
            {steps[wizardStep].content}
          </div>
        </Col>
      </Row>
    </>
  );
}
export default WizardForm;
